// extracted by mini-css-extract-plugin
export var content = "_48-3";
export var list = "_48-4";
export var settingsContent = "_48-7";
export var settingsPanel = "_48-8";
export var state = "_48-6";
export var triggerBadge = "_48-2";
export var triggerButton = "_48-1";
export var triggerShell = "_48-0";
export var unreadDot = "_48-5";